/* eslint-disable react/no-unescaped-entities */
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useEffect } from 'react'

import { MainContainer } from '~/components/atoms/main-container'
import { SeoTags } from '~/components/seo-tags'
import { useTracking } from '~/providers/tracking-provider'

const Page = () => {
	const { track } = useTracking()

	// TODO: Legacy tracking, remove?
	useEffect(() => {
		track.landingPage()
	}, [track])

	return (
		<>
			<SeoTags
				title='Qui sommes-nous ? - Cocoon Space'
				description='Vous vous demandez qui nous sommes et quel est notre parcours ? Venez découvrir notre histoire...'
			/>

			<MainContainer className='prose max-w-[800px]'>
				<h1>Qui sommes-nous ?</h1>

				<div>
					<h2>Notre histoire</h2>

					<p>
						Un jour nous avons voulu monter une super start-up... Habitant loin
						les uns des autres, nous nous retrouvions au bistrot. Les semaines
						passant nous n'avancions pas, l'évidence s'imposait !
					</p>

					<p>
						Professionnels aux parcours différents, nous avons vu nos activités
						évoluer grâce aux e-mails sur smartphone depuis une dizaine
						d'années. Les zones wifi et les ordinateurs ultra-portables se
						généralisant, c'est le bureau qui se déplace, le professionnel
						devient autonome et nomade.
					</p>

					<p>
						L'environnement conditionne la qualité du travail. Préparer un
						rendez-vous de qualité ne se fait ni dans un café internet au wifi
						non sécurisé où le hacking est garanti, ni dans un open-space fun et
						décontracté. Un échange professionnel ne se fait pas entre un
						ordinateur et une assiette, sous l'œil d'un serveur, ou, pire
						encore, à la maison où l'on risque d'être sollicité par mille
						choses. Un environnement exclusif est garant de la pertinence de la
						collaboration et du travail.
					</p>

					<p>
						Nous avons eu besoin d'un vrai bureau pour seulement 3 heures de
						temps en temps, sans nous engager par un abonnement, là où on
						voulait, en fonction de nos agendas, l'hyper-flexibilité devait être
						de mise.
					</p>

					<p>
						Notre projet initial ? Nous l'avons abandonné pour Cocoon-Space qui
						développe des applications mobiles afin d'aider les professionnels
						nomades à améliorer leur efficacité et leur confort au travail, en
						leur proposant un service de réservation à l'heure, d'espaces
						privés, calmes et confortables pour travailler comme s'ils étaient
						chez eux sans risque d'être dérangés.
					</p>
				</div>

				<div>
					<h2>Sylvain</h2>

					<p>
						CEO et co-fondateur de Cocoon Space. Sylvain a plus de 10 ans
						d'expérience dans la conception et le design d'applications mobiles
						et de sites web.
					</p>
				</div>

				<div>
					<h2>Jean-Yim</h2>

					<p>
						COO et co-fondateur de Cocoon Space. Manager d'un grand
						établissement de restauration pendant plus de 8 ans, Jean-Yim
						s'occupe du choix et de la gestion opérationnelle de nos espaces
					</p>
				</div>
			</MainContainer>
		</>
	)
}

export default Page

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
	props: {
		...(await serverSideTranslations(locale as string, [...defaultI18nNs])),
	},
})
